import { FC, ReactNode, useCallback } from 'react';
import styled from 'styled-components';

interface TableGridRowProps {
  children: ReactNode;
  index: number;
  fieldId: string;
  isLoading: boolean;
  removeRow?: (rowIndex: number) => void;
}

const StyledUnderlyingRemovingCell = styled.td`
  width: 1.5rem;
`;

export const TableGridRow: FC<TableGridRowProps> = ({ index, children, fieldId, isLoading, removeRow }) => {
  const canRemoveRow = removeRow !== undefined;
  const onClick = useCallback(() => removeRow!(index), [index, removeRow]);
  return (
    <tr>
      {children}
      {canRemoveRow && (
        <StyledUnderlyingRemovingCell className="align-middle text-center px-1">
          <button
            className="btn btn-icon"
            disabled={isLoading}
            onClick={onClick}
            type="button"
            data-e2e={fieldId + '-item-close'}
          >
            <i className="clickable icon text-secondary">delete</i>
          </button>
        </StyledUnderlyingRemovingCell>
      )}
      {isLoading && <div className="spinner-border spinner-border-sm text-light flex-shrink-0 flex-grow-0" />}
    </tr>
  );
};
